import React, { useEffect, useState } from 'react';
import { Box, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, List, ListItemButton, ListItemText, Stack, Select, MenuItem, InputLabel, FormControl, Chip, Typography } from '@mui/material';
import apiAxiosInstance from '../../utils/axiosInstance';

type Props = {
  open: boolean;
  onClose: () => void;
  onSelect: (strategy: { name: string; description?: string }) => void;
};

const StrategyPicker: React.FC<Props> = ({ open, onClose, onSelect }) => {
  const [query, setQuery] = useState('');
  const [tier, setTier] = useState<number|''>('');
  const [list, setList] = useState<any[]>([]);

  useEffect(() => {
    if (!open) return;
    const load = async () => {
      try {
        const res = await apiAxiosInstance.get('/api/behavior/strategy-library', { params: { query, tier } });
        setList(res.data || []);
      } catch { setList([]); }
    };
    load();
  }, [open, query, tier]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Pick a Strategy</DialogTitle>
      <DialogContent>
        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
          <TextField fullWidth size="small" label="Search" value={query} onChange={(e) => setQuery(e.target.value)} />
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel id="tier-label">Tier</InputLabel>
            <Select labelId="tier-label" label="Tier" value={tier} onChange={(e) => setTier(e.target.value as any)}>
              <MenuItem value=""><em>Any</em></MenuItem>
              <MenuItem value={1}>Tier 1</MenuItem>
              <MenuItem value={2}>Tier 2</MenuItem>
              <MenuItem value={3}>Tier 3</MenuItem>
            </Select>
          </FormControl>
        </Stack>
        <Box sx={{ maxHeight: 440, overflow: 'auto' }}>
          <List>
            {list.map((s) => (
              <ListItemButton key={s._id} alignItems="flex-start" onClick={() => { onSelect({ name: s.name, description: s.description }); onClose(); }}>
                <ListItemText 
                  primary={
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>{s.name}</Typography>
                      <Chip size="small" label={`Tier ${s.tier || 1}`} />
                      {(s.tags || []).slice(0,3).map((t: string) => <Chip key={t} size="small" label={t} variant="outlined" />)}
                    </Stack>
                  }
                  secondary={
                    <>
                      <Typography variant="body2" color="text.secondary">{s.description}</Typography>
                      {s.whenToUse && <Typography variant="caption" color="text.secondary">When to use: {s.whenToUse}</Typography>}
                    </>
                  }
                />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default StrategyPicker;


